import axios from 'axios'
import qs from 'qs'

// 正式地址
const BASE_URL = 'https://ar.lanxiongtiyu.com'

// 测试地址
// const BASE_URL = 'https://artest.lanxiongtiyu.com'

// 后台本地地址
// const BASE_URL = 'http://192.168.1.110:8081'

const request = axios.create({
  baseURL: `${BASE_URL}/ar_api/v1`,
  timeout: 80000
})

request.interceptors.request.use(
  config => {
    if (config.method.toLowerCase() === 'post' && (config.url === '/orderInfo/add.do' || config.url === '/aRInvoiceInfo/add.do')) {
      config.headers['Content-Type'] = 'application/json'
      config.data = JSON.stringify(config.data)
    } else if (config.method.toLowerCase() === 'post' && (config.url !== '/orderInfo/add.do' || config.url !== '/aRInvoiceInfo/add.do')) {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
      config.data = qs.stringify(config.data)
    } else {
      config.headers['Content-Type'] = 'application/json'
      config.params = config.data
      config.data = null
    }
    return config
  },
  err => {
    const error = {
      type: 'connection',
      url: window.location.href,
      err
    }
    return Promise.reject(error)
  }
)

request.interceptors.response.use(
  response => {
    const {
      data
    } = response
    return data
  },
  err => {
    return Promise.reject(err)
  }
)

export default request
